import ReviewIndexPage from './ReviewIndexPage';
export default ReviewIndexPage;